import { clsx } from 'clsx'
import { type ComponentPropsWithRef, type ReactElement } from 'react'

import styles from './hero-card.module.css'

export type HeroCardProps = ComponentPropsWithRef<'div'>

export function HeroCard(props: HeroCardProps): ReactElement {
  const { className, children, ...rest } = props

  return (
    <div className={clsx(styles.card, className)} {...rest}>
      {children}
    </div>
  )
}
